import colors from "./colors";
import typography_old, { typography } from "./typography";

const common = {
    primaryOnButton: {
        backgroundColor: colors.primaryColor400,
        height: 48,
        width: '100%'
    },
    primaryOffButton: {
        backgroundColor: colors.mono800,
        height: 48,
        width: '100%'
    },
    secondaryButton: {
        backgroundColor: colors.secondaryColor800,
        height: 48,
        width: '100%'
    },
    primaryButtonText: {
        ...typography_old.body.regular_15,
        color: colors.white
    },
    primaryMonoButton: {
        backgroundColor: colors.ctaDarkMode,
        height: 48,
        width: '100%'
    },
    primaryMonoButtonText: {
        ...typography_old.body.regular_15,
        color: colors.black
    },
    bigButtonSurface: {
        backgroundColor: colors.secondaryColor800,
        height: 90,
        flex: 0.5,
        borderRadius: 20,
        borderWidth: 1
    },
    bigButtonPrimary: {
        backgroundColor: colors.primaryColor900,
        height: 90,
        flex: 0.5
    },
    bigButtonSurfaceText: {
        ...typography_old.body.regular_15,
        color: colors.mono100
    },
    inputLabel: {
        ...typography.body["14_regular"],
        color: colors.mono0,
        marginBottom: 8
    }

}

export default common